import React, { useEffect, useState } from 'react';
import { ChevronRightIcon } from 'lucide-react';
export const IntroScreen = ({
  onStart,
  onCursorChange
}) => {
  const [logoAnimated, setLogoAnimated] = useState(false);
  const [buttonVisible, setButtonVisible] = useState(false);
  useEffect(() => {
    // Simplified animation sequence
    const logoTimer = setTimeout(() => setLogoAnimated(true), 500);
    const buttonTimer = setTimeout(() => setButtonVisible(true), 1200);
    return () => {
      clearTimeout(logoTimer);
      clearTimeout(buttonTimer);
    };
  }, []);
  return <div className="fixed inset-0 bg-gradient-to-b from-[#0a0e14] to-[#030508] z-[100] flex flex-col items-center justify-center" data-id="element-1028">
      <style jsx global data-id="element-1029">{`
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes scale-in {
          from {
            transform: scale(0.8);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }
        .logo-container {
          animation: ${logoAnimated ? 'scale-in 1.2s cubic-bezier(0.23, 1, 0.32, 1) forwards' : 'none'};
          opacity: 0;
        }
        .start-button {
          animation: ${buttonVisible ? 'fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards' : 'none'};
          opacity: 0;
        }
        .start-button:hover .button-glow {
          animation: glow-pulse 2s infinite;
        }
        .logo-pulse {
          animation: glow-pulse 4s infinite;
        }
        @keyframes glow-pulse {
          0%,
          100% {
            filter: drop-shadow(0 0 8px rgba(111, 248, 240, 0.4));
          }
          50% {
            filter: drop-shadow(0 0 15px rgba(111, 248, 240, 0.7));
          }
        }
      `}</style>
      {/* Logo */}
      <div className="logo-container mb-8 relative" data-id="element-1030">
        <div className="w-28 h-28 relative" data-id="element-1031">
          <svg viewBox="0 0 100 100" className="w-full h-full logo-pulse" data-id="element-1032">
            <defs data-id="element-1033">
              <linearGradient id="introLogoGradient" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-1034">
                <stop offset="0%" stopColor="#6ff8f0" data-id="element-1035" />
                <stop offset="100%" stopColor="#2a4d7f" data-id="element-1036" />
              </linearGradient>
              <filter id="introGlow" x="-20%" y="-20%" width="140%" height="140%" data-id="element-1037">
                <feGaussianBlur stdDeviation="3" result="blur" data-id="element-1038" />
                <feComposite in="SourceGraphic" in2="blur" operator="over" data-id="element-1039" />
              </filter>
            </defs>
            {/* Outer circle */}
            <circle cx="50" cy="50" r="45" fill="none" stroke="url(#introLogoGradient)" strokeWidth="2" data-id="element-1040" />
            {/* Inner circle */}
            <circle cx="50" cy="50" r="35" fill="none" stroke="url(#introLogoGradient)" strokeWidth="1" opacity="0.6" data-id="element-1041" />
            {/* Digital circuit lines */}
            <path d="M30,50 L70,50 M50,30 L50,70 M40,40 L60,60 M40,60 L60,40" stroke="url(#introLogoGradient)" strokeWidth="1.5" opacity="0.8" data-id="element-1042" />
            {/* Center node */}
            <circle cx="50" cy="50" r="10" fill="url(#introLogoGradient)" filter="url(#introGlow)" data-id="element-1043" />
            {/* Pulse animation */}
            <circle cx="50" cy="50" r="15" fill="none" stroke="url(#introLogoGradient)" strokeWidth="1" data-id="element-1044">
              <animate attributeName="r" from="10" to="30" dur="3s" repeatCount="indefinite" data-id="element-1045" />
              <animate attributeName="opacity" from="0.8" to="0" dur="3s" repeatCount="indefinite" data-id="element-1046" />
            </circle>
          </svg>
        </div>
      </div>
      {/* Start Button */}
      <div className="start-button flex flex-col items-center" data-id="element-1047">
        <button onClick={onStart} onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} className="group relative" data-id="element-1048">
          <div className="button-glow absolute inset-0 bg-[#6ff8f0] opacity-20 blur-lg rounded-full" data-id="element-1049"></div>
          <div className="relative glass px-14 py-4 rounded-full border border-[#6ff8f0]/30 flex items-center gap-3 
                          hover:bg-[#6ff8f0]/10 transition-all duration-500 overflow-hidden" data-id="element-1050">
            <span className="text-[#f0f6ff] font-mono tracking-wider text-lg" data-id="element-1051">
              START
            </span>
            <ChevronRightIcon size={20} className="text-[#6ff8f0] transition-transform duration-300 group-hover:translate-x-1" data-id="element-1052" />
            {/* Button highlights */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#6ff8f0]/0 via-[#6ff8f0]/10 to-[#6ff8f0]/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-1053"></div>
            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-4 h-4 border-t border-l border-[#6ff8f0]/70" data-id="element-1054"></div>
            <div className="absolute bottom-0 right-0 w-4 h-4 border-b border-r border-[#6ff8f0]/70" data-id="element-1055"></div>
          </div>
        </button>
      </div>
    </div>;
};